import Vue from 'vue'
import Toast from '@/components/StateWidgets/toast'
let ToastConstructor = Vue.extend(Toast) // 返回扩展实例构造器

let myToast = {}

myToast.show = ({
  text = 'toast text',
  duration = 3000,
  options = {}
} = {}) => {
  let toastDom = new ToastConstructor({
    el: document.createElement('div') // 将toast组件挂载到新创建的div上
  })
  toastDom.options = Object.assign({}, toastDom.options, options)
  toastDom.text = text
  toastDom.duration = duration
  document.body.appendChild(toastDom.$el)
  toastDom.isShow = true

  setTimeout(() => {
    toastDom.isShow = false
  }, toastDom.duration)
}

export default myToast
